<template>
  <div class="container-stock">
    <div class="d-flex justify-content-end">
      <small>Total : {{ form.total }} รายการ</small>
    </div>

    <div class="d-flex pt-6" :class="[activeChipFilter ? '' : 'py-6']">
      <v-col cols="11" class="ma-0 pa-0">
        <v-text-field
          v-model="form.search"
          type="text"
          color="#a50200"
          height="70"
          outlined
          append-icon="icon-Search"
          class="radius-10"
          v-on:keyup.enter="searchProduct"
        />
      </v-col>

      <v-col cols="1" class="ma-0 pa-0">
        <div class="card-icon-filter">
          <img
            src="img/icons_v2/icon-main-filter.png"
            width="35px"
            height="35px"
            alt="icon-filter"
            @click="drawerFilter = true"
          />
        </div>
      </v-col>
    </div>

    <ChipFilter v-show="activeChipFilter" :items="productFilter" @toggle="toggleChipFilter" />

    <!-- thead -->
    <div class="card-thead">
      <div class="th" style="width:5%;">&nbsp;&nbsp;</div>
      <div class="th" style="width:26%;">
        <div class="th-sort">
          <span class="w-100 f-22">ชื่อสินค้า</span>
          <img :src="iconSort" class="icon-sort" @click="sortedString(table, 'name')" />
        </div>
      </div>
      <div class="th" style="width:23%;">
        <div class="th-sort position-relative">
          <div class="icon-attention">
            <img :src="iconAttention" width="22px" height="22px" @click="openToolTipt('in')" />
            <div v-show="tooltipt_in" class="tooltiptext">
              <span class="f-20">ราคาซื้อเข้า (รวมVAT และค่าขนส่ง)</span>
            </div>
          </div>
          <span class="w-100 f-22">ราคาซื้อเข้า</span>
          <img :src="iconSort" class="icon-sort" @click="sortedNumber(table, 'wholesale_price')" />
        </div>
      </div>
      <div class="th" style="width:23%;">
        <div class="th-sort position-relative" style="margin: 0px 15px;">
          <div class="icon-attention">
            <img :src="iconAttention" width="22px" height="22px" @click="openToolTipt('out')" />
            <div v-show="tooltipt_out" class="tooltiptext" style="right: 9rem;">
              <span class="f-20">ราคาขายออก (รวมVAT ไม่รวมค่าขนส่ง)</span>
            </div>
          </div>

          <span class="w-100 f-22">ราคาขายออก</span>
          <img :src="iconSort" class="icon-sort" @click="sortedNumber(table, 'retail_price')" />
        </div>
      </div>
      <div class="th" style="width:18%;">
        <div class="th-sort" style="margin: 0px 15px;">
          <span class="w-100 f-22">สต๊อกแชร์</span>
          <img :src="iconSort" class="icon-sort" @click="sortedNumber(table, 'stock')" />
        </div>
      </div>
      <div class="th" style="width:5%;">&nbsp;&nbsp;</div>
    </div>

    <!-- tbody -->
    <div class="scroll" :class="{ action: activeChipFilter }">
      <div v-for="(i, k) in table" :key="k" class="card-tbody" :class="{ 'bk-none': k % 2 }">
        <div class="td px-1" style="width:5%;">{{ k + 1 }}.</div>
        <div class="td" style="width:26%;" @click="actionDialogPrice(i, k)">
          <div class="position-relative">
            <div class="text-overflows text-left">
              <span>{{ i.name }}</span>
            </div>
          </div>
        </div>
        <div class="td td-colum" style="width:23%;">
          <v-text-field
            v-model="i.wholesale_price"
            type="number"
            placeholder="0"
            suffix="฿"
            class="field-number centered-input"
            @input="inputNumber(k)"
          />
        </div>
        <div class="td td-colum" style="width:23%;">
          <v-text-field
            v-model="i.retail_price"
            type="number"
            placeholder="0"
            suffix="฿"
            class="field-number centered-input"
            @input="inputNumber(k)"
          />
        </div>
        <div class="td td-colum" style="width:18%;">
          <v-text-field
            v-model="i.stock"
            type="number"
            placeholder="0"
            :suffix="i.unit"
            class="field-number centered-input"
            @input="inputNumber(k)"
          />
        </div>
        <div class="td pa-0" style="width:5%;">
          <img
            :src="[i.status ? 'img/icons_v2/icon-checked.png' : 'img/icons_v2/icon-check.png']"
            width="30px"
            height="30px"
            @click="onSelectProduct(k)"
          />
        </div>
      </div>

      <ScrollLoader v-show="!loadMore" :loader-method="getProduct" :loader-enable="loadMore" />
    </div>

    <dialog-price
      :dialog="dialogPrice"
      :item="itemProduct"
      :indexItem="indexProduct"
      @inputNumber="inputNumber"
      @close="dialogPrice = false"
    />

    <div class="position-relative">
      <div class="footer-stock">
        <div class="m-3">
          <span>{{ productActive }} รายการ</span>
        </div>
        <div class="m-3">
          <v-btn class="btn-submit" :disabled="!actionSubmit" @click="saveForm()">บันทึก</v-btn>
        </div>
      </div>
    </div>

    <SidebarFilter
      :drawer="drawerFilter"
      @toggleDrawer="toggleDrawer"
      @filter="filterProduct"
      @cancel="filterProductReset"
    />
  </div>
</template>

<script>
import iconSort from '../../../../public/img/icons_v2/icon-sort.png'
import iconAttention from '../../../../public/img/icons_v2/icon-main-attention.png'
import DialogPrice from '@/components/v2/stock/DialogPrice.vue'
import SidebarFilter from '@/components/v2/stock/SidebarFilter.vue'
import ChipFilter from '@/components/v2/stock/ChipFilter.vue'
import { mapState } from 'vuex'
export default {
  props: ['customerId'],

  components: {
    DialogPrice,
    SidebarFilter,
    ChipFilter
  },

  data() {
    return {
      iconSort: iconSort,
      iconAttention: iconAttention,
      dataCustomers: [],

      isLoading: false,
      dialogPrice: false,
      dialogCf: false,

      form: {
        customer_id: this.customerId,
        search: '',
        page: 1,
        limit: 25,
        totalpages: 0,
        total: 0,
        group_id: []
      },

      orderBy: {
        name: false,
        retail_price: false,
        wholesale_price: false,
        stock: false
      },

      table: [],
      loadMore: false,
      itemProduct: '',
      indexProduct: null,

      drawerFilter: false,
      productFilter: [],
      tooltipt_in: false,
      tooltipt_out: false
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      accessToken: (state) => state.auth.accessToken
    }),

    productActive() {
      const data = this.activeProducts()
      return data.length
    },

    activeChipFilter() {
      return this.productFilter.length !== 0 ? true : false
    },

    actionSubmit() {
      var result = false
      this.table.forEach((element) => {
        if (element.status) {
          result = true
        }
      })

      return result
    }
  },

  methods: {
    searchProduct() {
      this.resetForm()
      setTimeout(() => {
        this.getProduct()
      }, 500)
    },

    resetForm() {
      this.form.page = 1
      this.form.limit = 25
      this.form.totalpages = 0
      this.form.total = 0
      this.table = []
    },

    getProduct() {
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        'Content-Type': 'application/json'
      }
      const options = {
        url: `${this.$baseAPI}/priceandstock/detail`,
        method: 'POST',
        data: this.form,
        headers: headers
      }

      this.$axios(options).then((res) => {
        const data = res.data.items
        this.form.totalpages = data.page.total
        this.form.total = data.page.total_row
        this.loadMore = this.form.page > this.form.totalpages // check total page
        data.list && (this.table = [...this.table, ...data.list]) // push items
        this.form.page++
      })
    },

    actionDialogPrice(item, index) {
      this.indexProduct = index
      this.itemProduct = item
      this.dialogPrice = !this.dialogPrice
    },

    activeProducts() {
      const data = this.table
      var result = []
      data.map((res) => {
        if (res.status) {
          result.push(res)
        }
      })
      return result
    },

    saveForm() {
      const product = this.activeProducts()
      if (product.length > 0) {
        this.$emit('save', product)
      }
    },

    onSelectProduct(index) {
      const stateStatus = this.table[index].status
      this.table[index].status = !stateStatus
    },

    inputNumber(index) {
      this.table[index].status = true
    },

    toggleDrawer() {
      this.drawerFilter = false
    },

    filterProduct(item) {
      this.resetForm()
      this.productFilter = item
      this.form.group_id = this.productFilter
    },

    filterProductReset() {
      this.productFilter = []
    },

    toggleChipFilter(item) {
      const data = this.productFilter
      var check = false

      data.forEach((element, index) => {
        if (element.id == item.id) {
          check = true
          this.productFilter.splice(index, 1)
        }
      })

      if (!check) {
        this.productFilter.push(item)
      }

      this.resetForm()
      this.form.group_id = this.productFilter
    },

    openToolTipt(value) {
      if (value === 'in') {
        this.tooltipt_in = !this.tooltipt_in
      } else if (value === 'out') {
        this.tooltipt_out = !this.tooltipt_out
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container-stock {
  background: #ffffff;
  width: 100%;
  margin-top: 1rem;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%);
  height: 75rem;
  max-height: 75rem;
  padding: 25px;
}

.radius-10 {
  border-radius: 10px;
}

.card-thead {
  display: flex;
  align-items: center;
  background: #444444;
  border-radius: 9px;
  color: white;
  font-weight: bold;
  width: 100%;
  height: 70px;
  padding: 0px 20px;
  margin: -20px 0px;

  & .th {
    text-align: center;
    border-right: 1px solid white;
  }
}

.card-tbody {
  background: #eaeaea;
  border-radius: 8px;

  display: flex;
  align-items: center;
  width: 100%;
  padding: 0px 10px;
  margin: 15px 0px;
  & .td {
    text-align: center;
    padding: 15px;
  }

  & .td-colum {
    padding: 0px 25px;
  }

  &.bk-none {
    background: none;
  }
}

.scroll {
  margin: 20px 0px;
  max-height: 740px;
  height: 740px;
  overflow: scroll;
  &.action {
    height: 645px !important;
  }
}

.text-overflows {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.btn-submit {
  border: none;
  background: #a50200;
  color: white;
  font-weight: bold;
  padding: 10px 0px;
}

.footer-stock {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.th-sort {
  display: flex;
  align-items: center;
  margin: 0 25px;
  justify-content: space-between;
}

.icon-sort {
  width: 8px;
  height: 14px;
}

.bk-shadow {
  box-shadow: 0 -2px 16px 0 rgba(0, 0, 0, 0.05), 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

* {
  scrollbar-width: thin;
}

*::-webkit-scrollbar {
  width: 5px;
}

*::-webkit-scrollbar-thumb {
  border-radius: 5px;
}

//

.item-attention {
  position: absolute;
  right: -17%;
  top: 10%;
}

.tooltiptext {
  width: 300px;
  background-color: #ffffff;
  color: black;
  text-align: center;
  border-radius: 9px;
  padding: 10px;
  position: absolute;
  bottom: 150%;
  right: 8rem;
  z-index: 100;
  box-shadow: rgb(136 165 191 / 48%) 4px 5px 16px 0px, rgb(255 255 255 / 80%) -6px -2px 16px 0px;
  opacity: 0;
  transition: 1s;
  font-size: 20px;
}

.tooltiptext::after {
  content: '';
  position: absolute;
  top: 100%;
  right: 3%;
  margin-left: -7px;
  border-width: 7px;
  border-style: solid;
  border-color: white transparent transparent transparent;
}

.icon-attention:hover .tooltiptext {
  opacity: 1;
}

.footer-stock {
  position: absolute;

  width: 100%;
  height: 100px !important;
  padding: 10px 0px 10px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-icon-filter {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
}

.btn-tags-filter {
  border: 1px solid #a50200;
  border-radius: 9px;
  background-color: #fff1f1;
  padding: 10px 15px;
  color: #a50200;
}
</style>
